import React, {Fragment} from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {Box} from "@mui/system";
import styles from "./Styles.module.css";

export default function CharacterChecker({label, isChecked, hasError}) {

  return(
    <Fragment>
      {isChecked ?
        <CheckCircleIcon className={ hasError ? styles.iconError : styles.icon } /> :
        <RadioButtonUncheckedIcon className={ hasError ? styles.iconError : styles.icon } />
      }
      <Box className={ hasError ? styles.labelError : styles.label}>
        {label}
      </Box>
    </Fragment>
  )
}